'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var style = require('../../transformers/style.js');
var index = require('../Icon/index.js');
var index$1 = require('../SelectItem/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const PudoTitle = styled__default["default"].div.withConfig({
  componentId: "sc-vk2k4a-0"
})(["font-weight:700;grid-area:Title;align-self:center;justify-self:start;", " color:inherit;"], _ref => {
  let {
    theme
  } = _ref;
  return style.getFontSizing(theme.headersMediumNone, {
    fontSize: '18px'
  });
});
const PudoSubtitle = styled__default["default"].div.withConfig({
  componentId: "sc-vk2k4a-1"
})(["grid-area:Subtitle;align-self:start;justify-self:start;", " color:inherit;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
});
const PudoExtraInfo = styled__default["default"].div.withConfig({
  componentId: "sc-vk2k4a-2"
})(["grid-area:ExtraInfo;", " font-weight:700;color:inherit;display:flex;flex-direction:column;align-self:center;align-items:end;justify-content:center;@media screen and (max-width:768px){align-items:start;}"], _ref3 => {
  let {
    theme
  } = _ref3;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
});
const PudoIcon = styled__default["default"](index["default"]).withConfig({
  componentId: "sc-vk2k4a-3"
})(["grid-area:Icon;grid-template-rows:span(2);width:52px;"]);
const PudoCardStyle = styled__default["default"](index$1["default"]).withConfig({
  componentId: "sc-vk2k4a-4"
})(["position:relative;"]);
const PudoCardGrid = styled__default["default"].div.withConfig({
  componentId: "sc-vk2k4a-5"
})(["display:grid;grid-auto-flow:column;width:100%;grid-template-areas:'Icon Title ExtraInfo' 'Icon Subtitle ExtraInfo';grid-template-columns:auto 2fr 1.25fr;column-gap:28px;@media screen and (max-width:768px){grid-template-areas:'Icon Title' 'Icon Subtitle' 'Icon ExtraInfo';grid-template-columns:auto 2fr;}"]);
const FavoriteIcon = styled__default["default"](index["default"]).withConfig({
  componentId: "sc-vk2k4a-6"
})(["position:absolute;top:8px;right:8px;"]);

exports.FavoriteIcon = FavoriteIcon;
exports.PudoCardGrid = PudoCardGrid;
exports.PudoCardStyle = PudoCardStyle;
exports.PudoExtraInfo = PudoExtraInfo;
exports.PudoIcon = PudoIcon;
exports.PudoSubtitle = PudoSubtitle;
exports.PudoTitle = PudoTitle;
